import { render, staticRenderFns } from "./sendDetail.vue?vue&type=template&id=9ee02192&scoped=true&"
import script from "./sendDetail.vue?vue&type=script&lang=js&"
export * from "./sendDetail.vue?vue&type=script&lang=js&"
import style0 from "./sendDetail.vue?vue&type=style&index=0&id=9ee02192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee02192",
  null
  
)

export default component.exports